import { render, staticRenderFns } from "./WorkOrderOverview.vue?vue&type=template&id=8406397a&scoped=true"
import script from "./WorkOrderOverview.vue?vue&type=script&lang=js"
export * from "./WorkOrderOverview.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderOverview.vue?vue&type=style&index=0&id=8406397a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8406397a",
  null
  
)

export default component.exports